import React, { useEffect, useState } from "react";
import Header from "../Components/Header/Header";
import { API } from "../constant";
import { authFetch } from "../helpers";
import { useAuthContext } from "../context/AuthContext";
import Loading from "../Components/Hooks/Loading";
import SkillItem from "../Components/Skills/SkillItem";
import "./Form.css";
import "./RCA.css";
import Footer from "../Components/Footer/Footer";

const RCAO = () => {
    const [loading, setLoading] = useState(true);
    const { isLoading } = useAuthContext();
    const [fielddata, setfielddata] = useState([]);
    const [stepIndex, setStepIndex] = useState(0);
    const [rcaInfo, setRcaInfo] = useState({});
    const [rcaSteps, setRcaSteps] = useState([]);

    const [selectedTriggers, setSelectedTriggers] = useState([]);
    const [selectedEmotions, setSelectedEmotions] = useState([]);
    const [selectedImmediateThoughts, setSelectedImmediateThoughts] = useState([]);
    const [recommendedSkills, setRrecommendedSkills] = useState([]);

    const descSelectHandler = () => {
        apiCall(stepIndex);
        const element = document.getElementById("form-popup");
        if (element) {
            element.classList.add("active-form");
        }
    };

    const closeButtonHandler = (e) => {
        const element = e.target.closest(".form-popup");
        if (e.target.classList.contains('active-form')) {
            e.target.classList.remove('active-form');
        } else if (e.target.classList.contains('close-button') || e.target.tagName === "SPAN") {
            element.classList.remove("active-form");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const rcaRes = await fetch(`${API}/rca?fields[0]=title&fields[1]=description&populate[0]=rca_steps.step_image`);
                const rcaData = await rcaRes.json();
                
                setRcaInfo({
                    title: rcaData.data.attributes.title,
                    description: rcaData.data.attributes.description[0].children[0].text,
                });

                const rcasteps = rcaData.data.attributes.rca_steps.map((item) => ({
                    title: item.title,
                    description: item.description[0].children[0].text,
                    image_url: item.step_image.data.attributes.url,
                }));
                setRcaSteps(rcasteps);

                const initialDataRes = await fetch(`${API}/triggers?pagination[pageSize]=100`);
                const initialData = await initialDataRes.json();
                setfielddata(initialData.data);

                setLoading(false);
            } catch (error) {
                console.error("Failed to fetch initial data:", error);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleOnChange = (event) => {
        const { checked } = event.target;
        const data_id = Number(event.target.getAttribute("data_id"));
        const currentStepTitle = rcaSteps[stepIndex]?.title;

        let updater;
        switch (currentStepTitle) {
            case "Trigger":
                updater = setSelectedTriggers;
                break;
            case "Emotion":
                updater = setSelectedEmotions;
                break;
            case "Immediate Thought":
                updater = setSelectedImmediateThoughts;
                break;
            default:
                return;
        }

        updater((prevSelected) => {
            if (checked) {
                return [...prevSelected, data_id];
            } else {
                return prevSelected.filter((id) => id !== data_id);
            }
        });
    };

    const apiCall = async (currentStepIndex) => {
        let url = "";
        if (currentStepIndex === 0) {
            url = `${API}/triggers?pagination[pageSize]=100`;
        } else if (currentStepIndex === 1) {
            if (selectedTriggers.length === 0) return;
            url = `${API}/emotions?pagination[pageSize]=100`;
        } else if (currentStepIndex === 2) {
            if (selectedTriggers.length === 0) return;
            url = `${API}/immediate-thoughts?pagination[pageSize]=100`;
        }

        if (url) {
            try {
                const res = await fetch(url);
                const data = await res.json();
                setfielddata(data.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
    };

    const next = () => {
        if (preventNext()) {
            const newIndex = stepIndex + 1;
            setStepIndex(newIndex);
            apiCall(newIndex);
        }
    };
    
    const prev = () => {
        if (stepIndex > 0) {
            const newIndex = stepIndex - 1;
            setStepIndex(newIndex);
            apiCall(newIndex);
        }
    };

    const preventNext = () => {
        if (stepIndex === 0) {
            return selectedTriggers.length > 0;
        }
        if (stepIndex === 1) {
            return selectedEmotions.length > 0;
        }
        if (stepIndex === 2) {
            return selectedImmediateThoughts.length > 0;
        }
        return false;
    };

    const onFinish = async (event) => {
        event.preventDefault();
        const immediateThoughtIds = selectedImmediateThoughts.join(',');
        const emotionIds = selectedEmotions.join(',');
        const triggerIds = selectedTriggers.join(',');

        console.log(immediateThoughtIds);
        console.log(emotionIds);
        console.log(triggerIds);

         const element = document.getElementById("form-popup");
        if (element.classList.contains('active-form')) {
            element.classList.remove('active-form');
        } else if (element.classList.contains('close-button') || element.tagName === "SPAN") {
            element.classList.remove("active-form");
        }


        if (selectedImmediateThoughts.length > 0) {
            const thoughtFilters = selectedImmediateThoughts.map((id) => {
                return `filters[immediate_thoughts][id][$in]=${id}`;
            }).join('&');
            try {
                const res = await authFetch(`${API}/skills?populate=*&${thoughtFilters}&pagination[pageSize]=100`);
                const data = await res.json();
                setRrecommendedSkills(data.data);
            } catch (error) {
                console.error("Error fetching skills:", error);
            }
        } else {
            console.warn("Please select an option for all steps before submitting.");
        }
    };

    const insertSpaces = (string) => {
        string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
        string = string.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
        string = string.replace(/[_,-]/g, ' ');
        return string;
    };
    
    const checkIcon = (
        <div className="checked">
            <span className="checkmark">
                <div className="checkmark_stem"></div>
                <div className="checkmark_kick"></div>
            </span>
        </div>
    );

    if (loading || isLoading) {
        return <Loading />;
    }

    return (
        <div className="common-bg skills">
            <div className="container">
                <Header title="Skills" />
                <div className="content-wrap bg-light">
                    <div className="content-wrap-inner">
                        <p className="description">{rcaInfo.description}</p>
                        <div className="rca form-fields-area">
                            <div className="rca">
                                <div className="rca-graphic">
                                    <div className="rca-graphic-inner">
                                        <div className="step rca-step-1">
                                            {rcaSteps[stepIndex] && <img src={rcaSteps[stepIndex].image_url} alt="RCA" />}
                                        </div>
                                    </div>
                                </div>
                                <p className="description">
                                    {rcaSteps[stepIndex]?.description}
                                    {rcaSteps.length - 1 > stepIndex && (
                                        <button type="button" onClick={descSelectHandler}>
                                            {rcaSteps[stepIndex].title}
                                        </button>
                                    )}
                                </p>
                            </div>
                            <form onSubmit={onFinish} id="create-course-form">
                                <div id={rcaSteps[stepIndex]?.title.toLowerCase()} className={`${rcaSteps[stepIndex]?.title.toLowerCase()} active`}>                                    
                                    <div id="form-popup" className="form-popup">
                                        <div className="form-popup-wrap">
                                            <div id="check" className="row check-wrap">
                                                <div onClick={closeButtonHandler} className="close-button"><span></span></div>
                                                <h3>{rcaSteps[stepIndex]?.title}</h3>
                                                {fielddata.map((item, index) => (
                                                    <div key={index} className="col-2 checkbox">
                                                        <label>
                                                            <input
                                                                className="checkbox-item"
                                                                id={item.id}
                                                                data_id={item.id}
                                                                type="checkbox"
                                                                name={item.attributes.title}
                                                                checked={
                                                                    (rcaSteps[stepIndex]?.title === "Trigger" && selectedTriggers.includes(item.id)) ||
                                                                    (rcaSteps[stepIndex]?.title === "Emotion" && selectedEmotions.includes(item.id)) ||
                                                                    (rcaSteps[stepIndex]?.title === "Immediate Thought" && selectedImmediateThoughts.includes(item.id))
                                                                }
                                                                onChange={handleOnChange}
                                                            />
                                                            {insertSpaces(item.attributes.title)}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="form-footer">
                                                {stepIndex !== 0 && <button className="button-left-arrow" type="button" onClick={prev}><span></span></button>}
                                                
                                                {rcaSteps.length > 0 && stepIndex === rcaSteps.length - 1 ? (
                                                    // Show Submit button on the last step
                                                    <button
                                                        className={`button-right-arrow theme-btn ${preventNext() ? "" : "disabled"}`}
                                                        type="submit"
                                                    >
                                                        Submit
                                                    </button>
                                                ) : (
                                                    // Show Next button on all other steps
                                                    <button
                                                        className={`button-right-arrow ${preventNext() ? "" : "disabled"}`}
                                                        type={"button"}
                                                        onClick={next}
                                                    >
                                                        <span></span>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="rca-skills">
                            <div className="form-area-inner">
                                <div className="skills">
                                    <div className="skills-inner">
                                        {recommendedSkills.map((item, index1) => (
                                            <SkillItem key={index1} SklItem={item.attributes} itemId={item.id} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default RCAO;